import { Add } from '@mui/icons-material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { FormGroup, FormLabel, Stack, Typography } from '@mui/material';
import CustomIconButton from 'common/components/CustomIconButton';
import CustomTextValidator from 'common/components/CustomTextValidators';
import CustomTooltip from 'common/components/CustomTooltip';
import useFlexBoxStyles from 'common/flexBox';
import useOnliveStyles from 'common/onliveStyles';
import { useFormFields } from 'libs/hooksLib';
import { useTranslation } from 'react-i18next';

const SharingParams = (props) => {
    const { sharingParams = {}, handleChange } = props;

    const [fields, handleFieldChange, resetForm] = useFormFields({
        key: '',
        value: '',
    });

    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const { classes: onlive } = useOnliveStyles();

    const handleAdd = () => {
        const newParams = { ...sharingParams };
        newParams[fields.key] = fields.value;
        handleChange(newParams);
        resetForm({ key: '', value: '' });
    };

    const handleDelete = (key) => {
        const newParams = { ...sharingParams };
        if (sharingParams.hasOwnProperty(key)) {
            delete newParams[key];
        }
        handleChange(newParams);
    };

    return (
        <Stack direction="column" className={flexBox.paddingTop2} spacing={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <FormLabel>{t('app.common.sharingParams').toUpperCase()}</FormLabel>
            </Stack>

            <Stack className={cx(flexBox.borderRadius1, onlive.borderSecondaryDark, flexBox.padding1)}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-end"
                    className={flexBox.padding1}
                >
                    <FormGroup>
                        <FormLabel>{t('form.fields.param')}</FormLabel>
                        <CustomTextValidator
                            name="key"
                            fullWidth={true}
                            variant="outlined"
                            size="small"
                            autoComplete="new-key"
                            value={fields.key}
                            onChange={handleFieldChange}
                            validators={['maxStringLength: 100']}
                            errorMessages={[t('profile.myAvailability.form.titleMaxLength')]}
                        />
                    </FormGroup>
                    <FormGroup>
                        <FormLabel>{t('form.fields.optionValue')}</FormLabel>
                        <CustomTextValidator
                            name="value"
                            fullWidth={true}
                            variant="outlined"
                            size="small"
                            autoComplete="new-value"
                            value={fields.value}
                            onChange={handleFieldChange}
                            validators={['maxStringLength: 100']}
                            errorMessages={[t('profile.myAvailability.form.titleMaxLength')]}
                        />
                    </FormGroup>

                    <CustomTooltip arrow title={t('calendar.common.add')} placement={'bottom'}>
                        <CustomIconButton
                            aria-label="delete"
                            onClick={() => handleAdd()}
                            size="small"
                            className={flexBox.marginBottom05}
                        >
                            <Add />
                        </CustomIconButton>
                    </CustomTooltip>
                </Stack>

                {Object.keys(sharingParams || {})?.map((key) => (
                    <Stack
                        direction="row"
                        key={key}
                        justifyContent="space-between"
                        alignItems="flex-start"
                        className={flexBox.padding1}
                    >
                        <Typography variant="subtitle2" fontWeight={500} className={flexBox.paddingLeft1}>
                            {key}
                        </Typography>
                        <Typography variant="subtitle2" fontWeight={500} className={flexBox.paddingLeft1}>
                            {sharingParams[key]}
                        </Typography>

                        <CustomTooltip arrow title={t('contact.remove')} placement={'bottom'}>
                            <CustomIconButton aria-label="delete" onClick={() => handleDelete(key)} size="small">
                                <DeleteOutlineOutlinedIcon />
                            </CustomIconButton>
                        </CustomTooltip>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default SharingParams;
